module.exports = __webpack_public_path__ + "static/diagram-c338ce9cac445f4e1fa23a167b533aca.svg";